export default {"src":"/_next/static/media/actions.8f3ca1a7.svg","height":448,"width":500};